import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/vehicle-manufacturer' 

export const constants = {
  data: {
    manufacturers: []
  }
}

export const get = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET', 
    url: `${baseEndpoint}`, 
    params: params
  })

  response.data.data.paginated_result?.forEach((val) => {
    val['can_edit'] = false
    val['can_delete'] = true
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: {
      manufacturer: data.manufacturer
    }
  })
  return response
}

export const deleteSingle = async (manufacturer) => {
  let response
  try {
    const res = await apiClient({
      method: 'DELETE',
      url: `${baseEndpoint}`,
      data: { manufacturer }
    })
    response = res
  } catch (error) {
    response = error?.response?.data
  }

  return response
}

export const deleteMany = async (ids) => {
  const _ids = ids.ids ?? ids
  const responses = await Promise.all(_ids?.map((id) => deleteSingle(id)))
  return responses.map((response) => response)
}
